import React from "react";
import { Stack } from "@mui/material";

import { FOUNDRIES } from "../../../constants";
import { HubButton } from "../../../components";

import { StyledTitleStack } from "../styles";

const PartRoutingBar = ({
  value,
  setValue = () => {},
}) => {
  return (
    <StyledTitleStack>
      <div style={{ width: "120px" }} />
      <Stack direction="row" gap="10px" alignItems="center">
        {FOUNDRIES?.map((f) => (
          <HubButton
            key={f.id}
            label={f.label}
            variant="contained"
            size="xsmall"
            onClick={() => setValue(f.id)}
            {...(value === f.id ? {} : { color: "grey" })}
          />
        ))}
      </Stack>
      <div style={{ width: "120px" }} />
    </StyledTitleStack>
  );
};

export default PartRoutingBar;
